import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=281301e6&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Collection.vue?vue&type=style&index=1&id=281301e6&lang=scss&scoped=true&"
import style2 from "./Collection.vue?vue&type=style&index=2&id=281301e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281301e6",
  null
  
)

export default component.exports